module.exports = __webpack_public_path__ + "static/media/contact-2.22c8fdd1.jpg";